<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div>&nbsp;</div>
      <ul class="nav" v-if="isMenuDefault">
        <li class="nav-item">
          <router-link :to="{ name: 'StartPage' }" class="nav-link"><i class="fa fa-home"></i> {{$lang.Menu.Items.StartPage}} </router-link>
        </li>
        <li class="nav-item" v-if="ztixMenuVisible">
          <a class="nav-link" exact @click="showMenuZTicket"><i class="fas fa-headset"></i> {{$lang.Menu.Items.ZTicket}} </a>
        </li>
        <li class="nav-title" v-if="hasRole(roles.MENU_OPERATIONAL)">
          {{$lang.Menu.Section.Operational}}
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_OPER_DOCUMENTS)">
          <a class="nav-link" exact @click="openZDocs"><i class="fas fa-hdd"></i> {{$lang.Menu.Items.Documents}} </a>
        </li>
        <!-- Sistema de Gestão (SG) standalone, cenário 3: qualquer uma das 3 roles do SG mostra o link.
             Some quando SistemaGestaoURL não está no ambiente (não há tela interna de fallback). -->
        <li class="nav-item" v-if="sistemaGestaoDisponivel && (hasRole(roles.RW_OPER_SG) || hasRole(roles.RW_OPER_SG_DIRETOR) || hasRole(roles.RW_OPER_SG_ADMIN))">
          <a class="nav-link" exact @click="showMenuSistemaGestao"><i class="fas fa-tasks"></i> {{$lang.Menu.Items.SistemaGestao}} </a>
        </li>
        <!-- ZGedCon (gestão de contratos) standalone, cenário 3. Some quando ZGedConURL não está
             no ambiente: igual ao zCurriculo, aqui NÃO existe tela interna pra cair como fallback. -->
        <li class="nav-item" v-if="hasRole(roles.RW_OPER_ZGEDCON) && zGedConDisponivel">
          <a class="nav-link" exact @click="openZGedCon"><i class="fas fa-file-contract"></i> {{$lang.Menu.Items.ZGedCon}} </a>
        </li>
        <!-- zCurriculo (ATS) standalone, cenário 3. Some quando ZCurriculoURL não está no ambiente:
             diferente do GED, aqui NÃO existe tela interna pra cair como fallback.
             RH com dois itens (decisão do Rodrigo, 2026-10-02): Gestão de Vagas abre a home do
             zCurriculo e DP abre `#/dp`, a primeira tela do Departamento Pessoal que a pessoa lê.
             Task 184 do zCurriculo (2026-10-08): o perfil do DP basta para ver o item do DP — não precisa
             mais do MENU do RH (RW_OPER_ZCURRICULO). -->
        <li class="nav-item nav-dropdown" v-if="(hasRole(roles.RW_OPER_ZCURRICULO) || zCurriculoVeDp()) && zCurriculoDisponivel">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-users"></i> {{$lang.Menu.Items.RH.Title}}</button>
          <ul class="nav-dropdown-items">
            <li class="nav-item" v-if="zCurriculoVeVagas()">
              <a class="nav-link" exact @click="openZCurriculo('')"><i class="fas fa-briefcase"></i> {{$lang.Menu.Items.RH.Vacancies}}</a>
            </li>
            <li class="nav-item" v-if="zCurriculoVeDp()">
              <a class="nav-link" exact @click="openZCurriculo('dp')"><i class="fas fa-id-card"></i> {{$lang.Menu.Items.RH.PersonnelDepartment}}</a>
            </li>
          </ul>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_OPER_GDOCS) || hasRole(roles.R_OPER_GDOCS)">
          <router-link :to="{ name: 'ArchiveDocumentsManagement' }" class="nav-link" ><i class="fas fa-file"></i> {{$lang.Menu.Items.ArchiveDocumentsManagement}} </router-link>
        </li>
        <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_OPER_PCI)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-table"></i> PCI</button>
          <ul class="nav-dropdown-items">
          <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI)">
            <router-link :to="{ name: 'PciSheets' }" class="nav-link"><i class="fas fa-table"></i> {{$lang.Menu.Items.PCI.Spreadsheets}}</router-link>
          </li>
          <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_OPER_PCI_ADM) || hasRole(roles.RW_OPER_PCI_ITEM) || hasRole(roles.RW_OPER_PCI_WORK)">
            <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-edit"></i> {{$lang.Menu.Items.PCI.Maintenance.Title}}</button>
            <ul class="nav-dropdown-items">
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ADM)">
                <router-link :to="{ name: 'CopType' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.CopType}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ADM)">
                <router-link :to="{ name: 'WkClassif' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.Maintenance.WorkClassification}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ITEM)">
                <router-link :to="{ name: 'PciItens' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.Items}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ADM)">
                <router-link :to="{ name: 'CopItem' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.CopItem}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ITEM)">
                <router-link :to="{ name: 'PciDicionarios' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.Dictionary}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_WORK)">
                <router-link :to="{ name: 'WorkMaintenance' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.WorkMaintenance}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ADM)">
                <router-link :to="{ name: 'ContractMaintenance' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.ContractMaintenance}}</router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_AT_LPU)" disabled>
            <router-link :to="{ name: 'Lpu' }" class="nav-link"><i class="fas fa-file-invoice-dollar"></i> {{$lang.Menu.Items.PCI.Lpu}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ADM)" disabled>
            <router-link :to="{ name: 'Montagem' }" class="nav-link"><i class="fas fa-table"></i> {{$lang.Menu.Items.PCI.Montage}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ADM)" disabled>
            <router-link :to="{ name: 'ServiceAnalysisTec' }" class="nav-link"><i class="fas fa-table"></i> {{$lang.Menu.Items.PCI.ServiceAnalysisTec}}</router-link>
          </li>
          <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_OPER_PCI_ADM)">
            <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-print"></i> {{$lang.Menu.Items.PCIReports.Title}}</button>
            <ul class="nav-dropdown-items">
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ADM)">
              <router-link :to="{ name: 'PciReports' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCIReports.Reports}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_ADM)">
                <router-link :to="{ name: 'PciReportLogs' }" class="nav-link"><i class="fas fa-list"></i> {{$lang.Menu.Items.PCIReports.Logs}}</router-link>
              </li>
            </ul>
          </li>
          </ul>
        </li>
        <li class="nav-item" v-if="hasRole(roles.R_OPER_PCI_ANTIGA)">
          <a class="nav-link" exact @click="openPciAntiga"><i class="fas fa-history"></i> {{$lang.Menu.Items.PciAntiga}} </a>
        </li>
        <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_OPER_PCI_PDR)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-table"></i> PDR</button>
          <ul class="nav-dropdown-items">
          <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR) || hasRole(roles.RW_OPER_PCI_PDR_BONUS) || hasRole(roles.RW_OPER_PCI_PDR_TECNICAL) || hasRole(roles.RW_OPER_PCI_PDR_EXCLUSION) || hasRole(roles.RW_OPER_PCI_PDR_PAYMENT)">
              <router-link :to="{ name: 'Pdr' }" class="nav-link"><i class="fas fa-table"></i> {{$lang.Menu.Items.PCI.PDRCurrent}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.R_OPER_PCI_PDR_ARCHIVED)">
              <router-link :to="{ name: 'PdrArquivados' }" class="nav-link"><i class="fas fa-table"></i> {{$lang.Menu.Items.PCI.PDRArchived}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_BONUS)" disabled>
              <router-link :to="{ name: 'PdrAnaliseFinal' }" class="nav-link"><i class="fas fa-table"></i> {{$lang.Menu.Items.PCI.PDRFinalAnalysis}}</router-link>
          </li>
          <li class="nav-item" v-if="(hasRole(roles.RW_OPER_PCI_PDR_TECNICAL) || hasRole(roles.RW_OPER_PCI_PDR_ENGINEERING))" disabled>
              <router-link :to="{ name: 'PdrBonusApproval' }" class="nav-link"><i class="fas fa-table"></i> {{$lang.Menu.Items.PCI.PDRBonusApproval}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_PAYMENT)" disabled>
              <router-link :to="{ name: 'PdrBonusPayment' }" class="nav-link"><i class="fas fa-file-invoice-dollar"></i> {{$lang.Menu.Items.PCI.PDRBonusPayment}}</router-link>
          </li>
          <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_BONUS)" disabled>
              <router-link :to="{ name: 'PdrDebits' }" class="nav-link"><i class="fas fa-dollar-sign"></i> {{$lang.Menu.Items.PCI.PDRDebits}}</router-link>
          </li>
          <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_OPER_PCI_PDR_REPORT)">
            <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-print"></i> {{$lang.Menu.Items.PCI.Reports}} </button>
            <ul class="nav-dropdown-items">
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_REPORT)" disabled>
                  <router-link :to="{ name: 'cadastrometas' }" class="nav-link"><i class="far fa-edit"></i> {{$lang.Menu.Items.PCI.PDRGoalRegistration}} </router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_REPORT)" disabled>
                  <router-link :to="{ name: 'relatorioitem' }" class="nav-link"><i class="fas fa-file-invoice-dollar"></i> {{$lang.Menu.Items.PCI.PDRItemRating}} </router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_REPORT)" disabled>
                  <router-link :to="{ name: 'relatoriofuncao' }" class="nav-link"><i class="fas fa-file-invoice-dollar"></i> {{$lang.Menu.Items.PCI.PDRRoleRationg}} </router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_REPORT)" disabled>
                  <router-link :to="{ name: 'PdrReportEvaluationMember' }" class="nav-link"><i class="fas fa-file-invoice-dollar"></i> {{$lang.Menu.Items.PCI.PDRAverageRating}} </router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_REPORT)">
                  <router-link :to="{ name: 'PDRValuesReport' }" class="nav-link"><i class="fas fa-list"></i> {{$lang.Menu.Items.PCIReports.SeePDRValues}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_REPORT)">
                  <router-link :to="{ name: 'StatusReport' }" class="nav-link"><i class="fas fa-file-alt"></i>{{$lang.Menu.Items.PCI.PDRStatusSearch}}</router-link>
              </li>
              <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_PDR_REPORT)">
                  <router-link :to="{ name: 'DebitsReport' }" class="nav-link"><i class="fas fa-file-alt"></i>{{$lang.Menu.Items.PCI.PDRDebitsReport}}</router-link>
              </li>
            </ul>
          </li>
          </ul>
        </li>
        <!-- Perfis proprios do relatorio (2026-09-10); RW_OPER_PCI_ADM continua entrando por ser admin da PCI. -->
        <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI_RELACOMP_GERAR) || hasRole(roles.RW_OPER_PCI_RELACOMP_FIXO) || hasRole(roles.RW_OPER_PCI_ADM)">
          <a class="nav-link" exact @click="openRelAcompPci"><i class="fas fa-chart-line"></i> {{$lang.Menu.Items.RelAcompPci}} </a>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_OPER_PCI)">
          <a class="nav-link" exact @click="openSmartCOP"><i class="fas fa-table"></i> {{$lang.Menu.Items.SmartCOP}} </a>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_OPER_ACQ)">
          <a class="nav-link" exact @click="showMenuZAcq"><i class="fas fa-table"></i>  {{$lang.Menu.Items.PCI.ZAcq}} </a>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_OPER_CTRL)">
          <a class="nav-link" exact @click="showMenuZControl"><i class="fas fa-table"></i>  {{$lang.Menu.Items.PCI.ZControl}} </a>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_OPER_MOI)">
          <a class="nav-link" exact @click="showMenuZMoi"><i class="fas fa-table"></i>  {{$lang.Menu.Items.PCI.ZMoi}} </a>
        </li>
        <li class="nav-item" v-if="pdrVeMenu()">
          <a class="nav-link" exact @click="showMenuPdr"><i class="fas fa-table"></i>  {{$lang.Menu.Items.PCI.Pdr}} </a>
        </li>

        <!-- IMOBILIARIA: junta o que estava espalhado nas secoes RealEstate, Requests,
             Reports, Consulta e Gestao. Roles inalteradas nesta etapa: so o agrupamento. -->
        <li class="nav-title" v-if="hasRole(roles.MENU_IMOB) || hasRole(roles.RW_REAL_ESTA_CRED) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
          {{$lang.Menu.Section.RealEstate}}
        </li>

        <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-folder-open"></i> Cadastros</button>
          <ul class="nav-dropdown-items">
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'empreendimento' }" class="nav-link"><i class="fas fa-building"></i> {{$lang.Menu.Items.Enterprise}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'credenciados' }" class="nav-link"><i class="fas fa-id-card-alt"></i> {{$lang.Menu.Items.Accredited}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'CustomerBoard' }" class="nav-link"><i class="fas fa-user"></i> {{$lang.Menu.Items.UserManagementAdm}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_CRED) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'RealtorBoard' }" class="nav-link"><i class="fas fa-user-tie"></i> {{$lang.Menu.Items.UserManagement}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'PriceTableManagement' }" class="nav-link"><i class="far fa-clipboard"></i> {{$lang.Menu.Items.PriceTableManagement}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'Announcements' }" class="nav-link"><i class="fa fa-bullhorn"></i> {{$lang.Menu.Items.Announcements}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'DocumentsManagement' }" class="nav-link"><i class="fas fa-file-alt"></i> {{$lang.Menu.Items.DocumentsManagement}}</router-link>
            </li>
          </ul>
        </li>

        <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_IMOB_VENDAS) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_CRED)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-cart-plus"></i> Vendas</button>
          <ul class="nav-dropdown-items">
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_VENDAS) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_CRED)">
              <router-link :to="{ name: 'Requests' }" class="nav-link"><i class="fas fa-file-signature"></i> {{$lang.Menu.Items.Requests}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_VENDAS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'Changedateofinstallment' }" class="nav-link"><i class="fas fa-calendar"></i> {{$lang.Menu.Items.Changedateofinstallment}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_VENDAS) || hasRole(roles.RW_REAL_ESTA_CRED)">
              <router-link :to="{ name: 'SalesInquiry' }" class="nav-link"><i class="fas fa-search-dollar"></i> {{$lang.Menu.Items.SalesInquiry}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_VENDAS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'Vendas' }" class="nav-link"><i class="fas fa-shopping-cart"></i> {{$lang.Menu.Items.Sales}}</router-link>
            </li>
          </ul>
        </li>

        <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_IMOB_COMISSOES) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_CRED)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-money-bill"></i> Comissões</button>
          <ul class="nav-dropdown-items">
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_COMISSOES) || hasRole(roles.RW_REAL_ESTA_CRED)">
              <router-link :to="{ name: 'CommissionCheck' }" class="nav-link"><i class="fas fa-comment-dollar"></i> {{$lang.Menu.Items.CommissionCheck}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_COMISSOES) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'Commissions' }" class="nav-link"><i class="fas fa-money-bill"></i> {{$lang.Menu.Items.Commissions}}</router-link>
            </li>
          </ul>
        </li>

        <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_IMOB_RELATORIOS) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_CRED)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-file-alt"></i> Relatórios</button>
          <ul class="nav-dropdown-items">
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_RELATORIOS) || hasRole(roles.RW_REAL_ESTA_CRED)">
              <router-link :to="{ name: 'SalesReportsBroker' }" class="nav-link"><i class="fas fa-clipboard-list"></i> {{$lang.Menu.Items.SalesReportsBroker}}</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_IMOB_RELATORIOS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
              <router-link :to="{ name: 'Relatoriodevendas' }" class="nav-link"><i class="fas fa-file-alt"></i> {{$lang.Menu.Items.Salesbyaccredited}}</router-link>
            </li>
          </ul>
        </li>

        <li class="divider"></li>

        <!-- OBRAS: era o dropdown "Controle de Ocorrencias" pendurado dentro da secao
             Gestao do imobiliario. E o unico bloco do RealEstateAPI com escrita ativa. -->
        <li class="nav-title" v-if="hasRole(roles.MENU_OBRAS) || hasRole(roles.RW_OBRAS_ADMIN) || hasRole(roles.RW_OBRAS_COORD) || hasRole(roles.RW_OBRAS_USER) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN_OBRA) || hasRole(roles.RW_REAL_ESTA_USER_OBRA) || hasRole(roles.RW_REAL_ESTA_COORD_OBRA)">
          OBRAS
        </li>

        <li class="nav-item nav-dropdown" v-if="hasRole(roles.MENU_OBRAS) || hasRole(roles.RW_OBRAS_ADMIN) || hasRole(roles.RW_OBRAS_COORD) || hasRole(roles.RW_OBRAS_USER) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN_OBRA) || hasRole(roles.RW_REAL_ESTA_USER_OBRA) || hasRole(roles.RW_REAL_ESTA_COORD_OBRA)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-cogs"></i> Controle de Ocorrências</button>
          <ul class="nav-dropdown-items">
            <li class="nav-item" v-if="hasRole(roles.MENU_OBRAS) || hasRole(roles.RW_OBRAS_ADMIN) || hasRole(roles.RW_OBRAS_COORD) || hasRole(roles.RW_OBRAS_USER) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN_OBRA) || hasRole(roles.RW_REAL_ESTA_USER_OBRA) || hasRole(roles.RW_REAL_ESTA_COORD_OBRA)">
              <router-link :to="{ name: 'ListaDeChamado' }" class="nav-link"><i class="fa fa-bullhorn"></i> Ocorrências</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_OBRAS_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN_OBRA)">
              <router-link :to="{ name: 'manutencaoOcorrencia' }" class="nav-link"><i class="fas fa-list-alt"></i> Manutenção Técnicos/Engenheiros</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_OBRAS_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN_OBRA)">
              <router-link :to="{ name: 'AlteracaoEmpreendimento' }" class="nav-link"><i class="fas fa-edit"></i> Nome de Empreendimento</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.MENU_OBRAS) || hasRole(roles.RW_OBRAS_ADMIN) || hasRole(roles.RW_OBRAS_COORD) || hasRole(roles.RW_OBRAS_USER) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN_OBRA) || hasRole(roles.RW_REAL_ESTA_USER_OBRA) || hasRole(roles.RW_REAL_ESTA_COORD_OBRA)">
              <router-link :to="{ name: 'Relatorios' }" class="nav-link"><i class="fa fa-clipboard"></i> Relatórios</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.MENU_OBRAS) || hasRole(roles.RW_OBRAS_ADMIN) || hasRole(roles.RW_OBRAS_COORD) || hasRole(roles.RW_OBRAS_USER) || hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.RW_REAL_ESTA_ADMIN_OBRA) || hasRole(roles.RW_REAL_ESTA_USER_OBRA) || hasRole(roles.RW_REAL_ESTA_COORD_OBRA)">
              <router-link :to="{ name: 'CustoTotal' }" class="nav-link"><i class="fas fa-money-check-alt"></i> Custo Total</router-link>
            </li>
          </ul>
        </li>

        <li class="divider"></li>

        <!-- Z PAG: junta a secao Financial (Reembolso viagem, Prestacao de contas,
             Quadro de funcionarios) com a secao Z Pag. Mesmo dominio, dois lugares. -->
        <li class="nav-title" v-if="hasRole(roles.RW_ZPAG_VIAGEM) || hasRole(roles.RW_ZPAG_DIVERSOS) || hasRole(roles.ACC_ZPAG_VIAGEM_CONSULTA) || hasRole(roles.ACC_ZPAG_DIVERSOS_CONSULTA) || hasRole(roles.RW_ZPAG_REEMBOLSO) || hasRole(roles.RW_ZPAG_QUADRO) || hasRole(roles.RW_ZPAG_PRESTACAO) || hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_BOARD_APPROVAL) || hasRole(roles.RW_FIN_TRAVELREFUND) || hasRole(roles.RW_FIN_BOARD)">
          Z Pag
        </li>

        <li class="nav-item" v-if="hasRole(roles.RW_ZPAG_VIAGEM) || hasRole(roles.ACC_FIN_TRAVELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_TRAVELLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_TRAVELCOORDINATOR_CENTRAL_LANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_TRAVELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
          <router-link :to="{ name: 'viagemdespesa' }" class="nav-link"><i class="fas fa-bus"></i> Despesas - Viagem</router-link>
        </li>
        <li class="nav-item" v-if="hasRole(roles.ACC_ZPAG_VIAGEM_CONSULTA)">
          <router-link :to="{ name: 'viagemdespesaconsulta' }" class="nav-link"><i class="fas fa-search-dollar"></i> Despesas - Viagem (Consulta)</router-link>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_ZPAG_DIVERSOS) || hasRole(roles.ACC_FIN_MISCELCOORDINATORLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.ACC_FIN_MISCELTECHNICIANLANEOUS_SEARCH_CONTROLLER_APPROVAL)">
          <router-link :to="{ name: 'ReemmbolsoDiversos' }" class="nav-link"><i class="fas fa-money-check"></i> Despesas - Diversos</router-link>
        </li>
        <li class="nav-item" v-if="hasRole(roles.ACC_ZPAG_DIVERSOS_CONSULTA)">
          <router-link :to="{ name: 'ReemmbolsoDiversosConsulta' }" class="nav-link"><i class="fas fa-search-dollar"></i> Despesas - Diversos (Consulta)</router-link>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_ZPAG_REEMBOLSO) || hasRole(roles.RW_FIN_TRAVELREFUND)">
          <router-link :to="{ name: 'RembolsoDespesas' }" class="nav-link"><i class="fas fa-bus-alt"></i> {{$lang.Menu.Items.TravelRefund}}</router-link>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_ZPAG_PRESTACAO) || hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_BOARD_APPROVAL)">
          <router-link :to="{ name: 'prestacaoconta' }" class="nav-link"><i class="fas fa-money-bill"></i> Prestação de contas</router-link>
        </li>
        <li class="nav-item" v-if="hasRole(roles.RW_ZPAG_QUADRO) || hasRole(roles.RW_FIN_BOARD)">
          <router-link :to="{ name: 'QdroFuncionario' }" class="nav-link"><i class="fas fa-address-card"></i> {{$lang.Menu.Items.Employeeboard}}</router-link>
        </li>

        <li class="divider"></li>

        <li class="nav-title" v-if="hasRole(roles.ACC_SURVEY)">
          Supervisão QMA/SST
        </li>

        <li class="nav-item" v-if="hasRole(roles.ACC_SURVEY)">
          <router-link :to="{ name: 'Tvistoria' }" class="nav-link"><i class="fas fa-hard-hat"></i> Supervisão SST</router-link>
        </li>

        <li class="nav-item nav-dropdown" v-if="hasRole(roles.RW_APR_ADMIN) || hasRole(roles.APR_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.APR_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.APR_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.APR_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.APR_COORDINATOR_APPROVAL) || hasRole(roles.MENU_APR)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-shield-alt"></i> APR</button>
          <ul class="nav-dropdown-items">
            <li class="nav-item" v-if="hasRole(roles.RW_APR_ADMIN) || hasRole(roles.APR_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.APR_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.APR_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.APR_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.APR_COORDINATOR_APPROVAL)">
              <router-link :to="{ name: 'Cadastro-Apr' }" class="nav-link"><i class="fas fa-list-alt"></i> Cadastro Básico</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_APR_ADMIN) || hasRole(roles.APR_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.APR_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.APR_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.APR_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.APR_COORDINATOR_APPROVAL)">
              <router-link :to="{ name: 'Template-Apr' }" class="nav-link"><i class="fas fa-folder-plus"></i> Cadastro de Template</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_APR_ADMIN) || hasRole(roles.APR_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.APR_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.APR_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.APR_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.APR_COORDINATOR_APPROVAL)">
              <router-link :to="{ name: 'Consulta-Apr' }" class="nav-link"><i class="fas fa-hard-hat"></i> Consultas</router-link>
            </li>
            <li class="nav-item" v-if="hasRole(roles.RW_APR_ADMIN) || hasRole(roles.APR_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.APR_COORDINATOR_APPROVAL)">
              <router-link :to="{ name: 'Relatorio-Apr' }" class="nav-link"><i class="fas fa-file-alt"></i> Relatório APR</router-link>
            </li>
          </ul>
        </li>

        <li class="nav-item nav-dropdown" v-if="hasRole(roles.MENU_QMA) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
          <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-award"></i> QMA</button>
          <ul class="nav-dropdown-items">
          <li class="nav-item nav-dropdown" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
              <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-folder-plus"></i>Cadastro de Template</button>
              <ul class="nav-dropdown-items">
                <li class="nav-item" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
                  <router-link :to="{ name: 'Template-Pivs'}" class="nav-link"><i class="fas fa-file-signature"></i>PIVS</router-link>
                </li>
                <li class="nav-item" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
                  <router-link :to="{ name: 'Template-Pit'}" class="nav-link"><i class="fas fa-file-signature"></i>PIT</router-link>
                </li>
                <li class="nav-item" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
                  <router-link :to="{ name: 'Template-Lv'}" class="nav-link"><i class="fas fa-file-signature"></i>LV</router-link>
                </li>
              </ul>
          </li>
          <li class="nav-item nav-dropdown" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
              <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-hard-hat"></i>Consultas</button>
              <ul class="nav-dropdown-items">
                <li class="nav-item" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
                  <router-link :to="{ name: 'Consulta-Pivs'}" class="nav-link"><i class="fas fa-file"></i>PIVS</router-link>
                </li>
                <li class="nav-item" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
                  <router-link :to="{ name: 'Consulta-Pit'}" class="nav-link"><i class="fas fa-file"></i>PIT</router-link>
                </li>
                <li class="nav-item" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
                  <router-link :to="{ name: 'Consulta-Lv'}" class="nav-link"><i class="fas fa-file"></i>LV</router-link>
                </li>
              </ul>
           </li>
            <li class="nav-item nav-dropdown" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
              <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-hard-hat"></i>Relatório QMA</button>
              <ul class="nav-dropdown-items">
                <li class="nav-item" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
                  <router-link :to="{ name: 'Relatorio-Qma-Pivs'}" class="nav-link"><i class="fas fa-file"></i>PIVS</router-link>
                </li>
                <li class="nav-item" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
                  <router-link :to="{ name: 'Relatorio-Qma-Pit'}" class="nav-link"><i class="fas fa-file"></i>PIT</router-link>
                </li>
                <li class="nav-item" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
                  <router-link :to="{ name: 'Relatorio-Qma-Lv'}" class="nav-link"><i class="fas fa-file"></i>LV</router-link>
                </li>
              </ul>
            </li>
            <li class="nav-item" v-if="hasRole(roles.QMA_RESEARCH_TECHNICIAN_VIEW) || hasRole(roles.QMA_RESEARCH_TECHNICAL_ENGINEER_VIEW) || hasRole(roles.QMA_RESEARCH_MASTER_IN_CHARGE_VIEW) || hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL) || hasRole(roles.QMA_COORDINATOR_APPROVAL)">
              <router-link :to="{ name: 'Relatorio-Lv-Vistorias'}" class="nav-link"><i class="fas fa-file-excel"></i>Relação de LVs e Vistorias</router-link>
            </li>
            <!--
              Cadastro Básico QMA: restrito ao ADMINISTRADOR (QMA_SEARCH_CONTROLLER_APPROVAL).
              Antes liberava para os 5 perfis (Técnico/Engenheiro/Supervisor/Coordenador/Admin),
              mas a regra de negócio definida em 2026-04-28 é só ADMIN ter acesso a este menu.
            -->
            <li class="nav-item nav-dropdown" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
              <button type="button" aria-expanded="false" class="nav-link nav-dropdown-toggle" @click="handleClick"><i class="fas fa-list-alt"></i>Cadastro Básico QMA</button>
              <ul class="nav-dropdown-items">
                <li class="nav-item" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
                  <router-link :to="{ name: 'Cadastro-Basico-PIVS-QMA'}" class="nav-link"><i class="fas fa-file"></i>PIVS</router-link>
                </li>
                <li class="nav-item" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
                  <router-link :to="{ name: 'Cadastro-Basico-PIT-QMA'}" class="nav-link"><i class="fas fa-file"></i>PIT</router-link>
                </li>
                <li class="nav-item" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
                  <router-link :to="{ name: 'Cadastro-Basico-LV-QMA'}" class="nav-link"><i class="fas fa-file"></i>LV</router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>

        <li class="divider"></li>

        <li class="nav-title d-none" >
          {{$lang.Menu.Section.Management}}
        </li>
        <li class="nav-item  d-none">
          <a class="nav-link" exact @click="showMenuReport"><i class="fa fa-bar-chart"></i> {{$lang.Menu.Items.Reports}} </a>
        </li>
        <li class="divider"></li>
        <li class="pt-5">&nbsp;</li>

      </ul>
      <transition name="fade">
        <ReportSidebar v-on:ReturnMenuDefault="showMenuDefault"  v-if="isMenuReport" />
        <SettingsSidebar v-on:ReturnMenuDefault="showMenuDefault" v-if="isMenuSettings" />
      </transition>
    </nav>
  </div>
</template>
<script>
import Roles from '@/shared/utils/roles.js'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import { actionTypes as AccountActions } from '@/store/module/account/actions'
import { actionTypes as CompanyActions } from '@/store/module/company/actions'
import SettingsSidebar from './sidebar/SettingsSidebar'
import ReportSidebar from './sidebar/ReportSidebar'

// Atrasos do peek (hover na barra minimizada). Entrada curta o bastante pra nao parecer
// travado, longa o bastante pra atravessar a barra de raspao sem abrir.
const PEEK_ENTRADA_MS = 120
const PEEK_SAIDA_MS = 220

export default {
  name: 'AppSidebar',
  mixins: [ AccountMixin, CompanyMixin, PermissionMixin ],
  data () {
    return {
      isMenuDefault: true,
      isMenuReport: false,
      isMenuSettings: false,
      // Launcher do ZTicket (Abertura de Chamados TI). Visível por env: aceite sim, prod off por enquanto.
      ztixMenuVisible: process.env.ZticketMenuVisible === true || process.env.ZticketMenuVisible === 'true',
      // Launcher do zCurriculo: a própria URL é o interruptor, em vez de uma flag separada — um
      // ambiente sem host não tem como ter menu que funcione. Prod entra com string vazia.
      zCurriculoDisponivel: !!process.env.ZCurriculoURL,
      sistemaGestaoDisponivel: !!process.env.SistemaGestaoURL,
      // Mesmo arranjo para o ZGedCon: a URL é o interruptor, e prod entra vazia.
      zGedConDisponivel: !!process.env.ZGedConURL,
      roles: Roles
    }
  },
  mounted () {
    this[AccountActions.GET_LOGGED]()
      .then((response) => {
        if (!this.company) {
          this[CompanyActions.GET_COMPANY_BY_ID](response.empresaID)
        }
      })
    this.$el.addEventListener('mouseenter', this.onSidebarPeekIn)
    this.$el.addEventListener('mouseleave', this.onSidebarPeekOut)
    // Teclado (chamado #20098): focusin/focusout borbulham, entao um par de listeners na
    // .sidebar cobre os 20 toggles e os 81 links, inclusive os do SettingsSidebar, que
    // renderiza dentro deste $el.
    this.$el.addEventListener('focusin', this.onSidebarPeekFocusIn)
    this.$el.addEventListener('focusout', this.onSidebarPeekOut)
    // Alt-tab com o mouse parado na barra nao dispara mouseleave, e ela ficava aberta por
    // cima do conteudo ate o mouse se mexer de novo. Verificado no browser.
    window.addEventListener('blur', this.onWindowBlur)
  },
  beforeDestroy () {
    this.$el.removeEventListener('mouseenter', this.onSidebarPeekIn)
    this.$el.removeEventListener('mouseleave', this.onSidebarPeekOut)
    this.$el.removeEventListener('focusin', this.onSidebarPeekFocusIn)
    this.$el.removeEventListener('focusout', this.onSidebarPeekOut)
    window.removeEventListener('blur', this.onWindowBlur)
    this.onSidebarPeekCancel()
  },
  components: {
    SettingsSidebar,
    ReportSidebar
  },
  methods: {
    // O toggle tem que ir no li.nav-item, nao no parentElement do alvo do clique.
    // Clicando no <i> do item, e.target e o <i> e o parentElement e a div.nav-link -
    // o 'open' ia parar na div e o submenu nao abria. O ganho e na barra EXPANDIDA.
    //
    // Encolhida e SEM peek nao toggla: nesse estado o CSS mantem
    // `.open > ul { display: none }`, entao marcar `open` nao abriria nada e so acenderia
    // o item com a cor de selecionado (_custom.scss:228), de forma permanente. Durante o
    // peek a barra esta com o CSS normal, entao o clique abre o acordeao como sempre.
    handleClick (e) {
      e.preventDefault()
      const body = document.body
      if (body.classList.contains('sidebar-minimized') && !body.classList.contains('sidebar-peek')) return
      const item = e.currentTarget.closest('.nav-item')
      if (!item) return
      // O `open` mora no li e e ligado na mao (nao ha estado Vue por tras), entao o
      // aria-expanded do botao tem que ser escrito no mesmo lugar - senao o leitor de
      // tela anuncia "recolhido" com o grupo aberto na tela.
      e.currentTarget.setAttribute('aria-expanded', String(item.classList.toggle('open')))
    },
    // Peek: com a barra minimizada, deixar o mouse nela devolve os 300px POR CIMA do
    // conteudo (o .main nao se mexe - ver _layout.scss). Sai sozinho ao tirar o mouse.
    // Os dois atrasos existem pra nao piscar: entrar so depois de o mouse ficar parado,
    // e sair com folga pra atravessar a fresta entre item e submenu.
    onSidebarPeekIn () {
      clearTimeout(this.peekTimer)
      if (!document.body.classList.contains('sidebar-minimized')) return
      this.peekTimer = setTimeout(() => document.body.classList.add('sidebar-peek'), PEEK_ENTRADA_MS)
    },
    onSidebarPeekOut () {
      clearTimeout(this.peekTimer)
      this.peekTimer = setTimeout(this.fecharPeek, PEEK_SAIDA_MS)
    },
    // Peek por teclado (chamado #20098). Sem atraso, ao contrario do mouse: os 120ms de
    // PEEK_ENTRADA_MS existem pra nao abrir quando o ponteiro atravessa a barra de raspao,
    // e foco nao atravessa nada - so entra por Tab deliberado. Abrir na hora tambem fecha a
    // janela em que um Tab+Enter rapido cairia na guarda de `handleClick` (que so toggla
    // com a barra expandida ou em peek) e o grupo nao abriria.
    // A saida reusa onSidebarPeekOut: os 220ms de PEEK_SAIDA_MS absorvem o par
    // focusout/focusin que o Tab dispara ao pular de um item da barra pro seguinte.
    onSidebarPeekFocusIn () {
      clearTimeout(this.peekTimer)
      if (!document.body.classList.contains('sidebar-minimized')) return
      document.body.classList.add('sidebar-peek')
    },
    // Alt-tab com o foco DENTRO da barra: nao ha mouseleave nem focusout, e ao voltar
    // tambem nao ha focusin (o foco nunca saiu). Fechar aqui deixaria o teclado parado num
    // item de 50px sem rotulo, sem evento nenhum pra reabrir.
    onWindowBlur () {
      if (this.$el && this.$el.contains(document.activeElement)) return
      this.onSidebarPeekCancel()
    },
    onSidebarPeekCancel () {
      clearTimeout(this.peekTimer)
      this.fecharPeek()
    },
    fecharPeek () {
      const body = document.body
      const voltaAEncolher = body.classList.contains('sidebar-minimized')
      body.classList.remove('sidebar-peek')
      // Grupo aberto durante o peek some de vista quando a barra volta pros 50px
      // (`.open > ul` fica `display: none` la), mas o item continua marcado e pintado
      // como selecionado - permanente, e um por grupo que o usuario tiver aberto.
      // Entao o acordeao fecha junto com o peek. Na barra expandida nao mexe: ali o
      // `open` e estado legitimo que o usuario ligou e espera encontrar de novo.
      if (voltaAEncolher && this.$el) {
        this.$el.querySelectorAll('.nav-item.nav-dropdown.open').forEach((li) => {
          li.classList.remove('open')
          // Filho direto na mao em vez de `:scope >`: o seletor :scope estoura SyntaxError
          // em engine que nao conhece, e aqui isso derrubaria o fecharPeek inteiro.
          const toggle = Array.prototype.find.call(li.children, (c) => c.classList.contains('nav-dropdown-toggle'))
          if (toggle) toggle.setAttribute('aria-expanded', 'false')
        })
      }
    },
    showMenuReport () {
      this.RemoveMinimizedSidebar()
      this.isMenuDefault = false
      this.isMenuReport = true
      this.isMenuSettings = false
    },
    showMenuDefault () {
      this.RemoveMinimizedSidebar()
      this.isMenuDefault = true
      this.isMenuReport = false
      this.isMenuSettings = false
    },
    showMenuSettings () {
      this.RemoveMinimizedSidebar()
      this.isMenuDefault = false
      this.isMenuReport = false
      this.isMenuSettings = true
    },
    showMenuZAcq () {
      const url = process.env.AcquisitionURL
      if (!url) {
        console.warn('AcquisitionURL não configurada para este ambiente')
        return
      }
      window.open(url, '_blank', 'noopener')
    },
    showMenuZMoi () {
      const url = process.env.MoiURL
      if (!url) {
        console.warn('MoiURL não configurada para este ambiente')
        return
      }
      window.open(url, '_blank', 'noopener')
    },
    // Departamento Pessoal aparece para quem tem perfil do DP (RW_OPER_DP_*, e os nomes antigos
    // RW_OPER_ZCUR_* na janela da troca — task 184 do zCurriculo).
    zCurriculoVeDp () {
      return [this.roles.RW_OPER_DP_ADMISSAO, this.roles.RW_OPER_DP_OBRA, this.roles.RW_OPER_DP_ARQUIV,
        this.roles.RW_OPER_DP_FERIAS, this.roles.RW_OPER_DP_RESCISAO,
        this.roles.RW_OPER_ZCUR_INCLUI, this.roles.RW_OPER_ZCUR_DPOBRA, this.roles.RW_OPER_ZCUR_ARQUIV,
        this.roles.RW_OPER_ZCUR_FERIAS, this.roles.RW_OPER_ZCUR_RESCIS].some((r) => this.hasRole(r))
    },
    // Gestão de Vagas aparece para quem tem perfil do RH. Também para quem tem só o MENU do RH, sem
    // perfil de vagas NEM do DP: é por ele que essa pessoa chega ao /403 do zCurriculo, que explica o
    // motivo. Quem é só do DP (sem o MENU) não vê Gestão de Vagas.
    zCurriculoVeVagas () {
      const vagas = [this.roles.RW_OPER_ZCUR_ADMIN, this.roles.RW_OPER_ZCUR_RECRUT, this.roles.RW_OPER_ZCUR_SOLIC]
        .some((r) => this.hasRole(r))
      return vagas || (this.hasRole(this.roles.RW_OPER_ZCURRICULO) && !this.zCurriculoVeDp())
    },
    // `rota` vazia abre a home do zCurriculo; `dp` abre `#/dp`.
    openZCurriculo (rota = '') {
      const base = process.env.ZCurriculoURL
      if (!base) {
        console.warn('ZCurriculoURL não configurada para este ambiente')
        return
      }
      const empresaId = this.company && this.company.id ? this.company.id : null
      // A query vai ANTES do hash de propósito: o zCurriculo roda em `vueRouterMode: hash` e o
      // `consumeParentContext` do auth-guard lê `window.location.search`. Com `#/?empresaId=`
      // o parâmetro cai dentro do hash, o `search` fica vazio e a empresa ativa se perde em silêncio.
      const query = empresaId ? `?empresaId=${encodeURIComponent(empresaId)}` : ''
      // `#/` e NÃO uma rota fixa: quem escolhe a tela é o `landing()` do zCurriculo, que lê as
      // permissões da sessão — AdminRH cai em `/dashboard`, recrutador e solicitante em
      // `/gestao-vagas`, e quem tem só `RW_OPER_ZCURRICULO` (o MENU, que concede zero) cai num
      // `/403` que diz o motivo. Com rota fixa no hash esse landing NUNCA roda: o `redirect` do
      // vue-router só resolve em `path: ''`.
      // O valor anterior era `#/vagas`, que além disso é a `VagaListPage` (grid CRUD) — e não a
      // `VagaGestaoPage` de `/gestao-vagas`, que é a tela que o rótulo deste item promete.
      //
      // `#/dp` é a outra entrada fixa e redireciona do mesmo jeito: a rota `/dp` do zCurriculo
      // escolhe a primeira tela do DP que a pessoa lê.
      window.open(`${base}/${query}#/${rota}`, '_blank', 'noopener')
    },
    // PDR novo: qualquer papel do PDR, ou do PCI-PDR que vale la como equivalente (escopo telecom).
    pdrVeMenu () {
      return [this.roles.RW_OPER_PDR, this.roles.RW_OPER_PDR_ADMIN, this.roles.RW_OPER_PDR_ABERTURA,
        this.roles.RW_OPER_PDR_REVISAO, this.roles.RW_OPER_PDR_REVISAO_DIRETOR, this.roles.RW_OPER_PDR_VALORES,
        this.roles.RW_OPER_PDR_APROVACAO, this.roles.RW_OPER_PDR_PAGAMENTO, this.roles.RW_OPER_PDR_TELECOM,
        this.roles.RW_OPER_PDR_TRADICIONAL, this.roles.RW_OPER_PCI_PDR, this.roles.R_OPER_PCI_PDR_VALUES,
        this.roles.R_OPER_PCI_PDR_ARCHIVED, this.roles.RW_OPER_PCI_EVALUATION, this.roles.RW_OPER_PCI_PDR_BONUS,
        this.roles.RW_OPER_PCI_PDR_TECNICAL, this.roles.RW_OPER_PCI_PDR_ENGINEERING, this.roles.RW_OPER_PCI_PDR_PAYMENT]
        .some((r) => this.hasRole(r))
    },
    showMenuPdr () {
      const url = process.env.PdrURL
      if (!url) {
        console.warn('PdrURL não configurada para este ambiente')
        return
      }
      window.open(url, '_blank', 'noopener')
    },
    showMenuZControl () {
      const url = process.env.ZcontrolURL
      if (!url) {
        console.warn('ZcontrolURL não configurada para este ambiente')
        return
      }
      window.open(url, '_blank', 'noopener')
    },
    showMenuSistemaGestao () {
      const url = process.env.SistemaGestaoURL
      if (!url) {
        console.warn('SistemaGestaoURL não configurada para este ambiente')
        return
      }
      window.open(url, '_blank', 'noopener')
    },
    showMenuZTicket () {
      const url = process.env.ZticketURL
      if (!url) {
        console.warn('ZticketURL não configurada para este ambiente')
        return
      }
      window.open(url, '_blank', 'noopener')
    },
    // ZDocs standalone (migração ZC-MigracaoZdocs): abre o módulo novo passando a empresa ativa via ?empresaId.
    // Sem ZDocsURL no ambiente (aceite/prod até a virada) → cai no GED interno, sem regressão.
    openZDocs () {
      const base = process.env.ZDocsURL
      if (!base) {
        this.$router.push({ name: 'GED' })
        return
      }
      const empresaId = this.company && this.company.id ? this.company.id : null
      // Abre direto na rota do módulo (hash). empresaId dentro do hash — o auth-guard do ZDocs lê ?empresaId da query OU do hash.
      const url = `${base}/#/documentos${empresaId ? `?empresaId=${encodeURIComponent(empresaId)}` : ''}`
      window.open(url, '_blank', 'noopener')
    },
    openZGedCon () {
      const base = process.env.ZGedConURL
      if (!base) {
        console.warn('ZGedConURL não configurada para este ambiente')
        return
      }
      const empresaId = this.company && this.company.id ? this.company.id : null
      // A query vai ANTES do hash de propósito: o ZGedCon roda em `vueRouterMode: hash` e o
      // `consumeParentContext` do auth-guard lê `window.location.search`. Com
      // `#/contratos?empresaId=` o parâmetro cai dentro do hash, o `search` fica vazio e a
      // empresa ativa se perde em silêncio. Mesma pegadinha do zCurriculo.
      const query = empresaId ? `?empresaId=${encodeURIComponent(empresaId)}` : ''
      window.open(`${base}/${query}#/contratos`, '_blank', 'noopener')
    },
    openSmartCOP () {
      // Abre o SmartCOP na casca limpa (sem menu lateral) — rota /cop-standalone do smartpci-frontend.
      const url = `${process.env.SmartPciBaseURL}/#/cop-standalone?empresaId=${this.company.id}`
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    openRelAcompPci () {
      // Abre o Relatorio de Acompanhamento na casca limpa (sem menu lateral) — rota
      // /acomp-pci-standalone do smartpci-frontend. O `empresaId` vai DENTRO do hash: o smartpci
      // roda em hash mode e quem le a query e o guard global do router (captureFromRoute).
      const url = `${process.env.SmartPciBaseURL}/#/acomp-pci-standalone?empresaId=${this.company.id}`
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    openPciAntiga () {
      // Abre a consulta do PCI Antigo na casca limpa (sem menu lateral) — rota /pci-antiga/consulta.
      const url = `${process.env.SmartPciBaseURL}/#/pci-antiga-standalone?empresaId=${this.company.id}`
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    RemoveMinimizedSidebar: function () {
      document.body.classList.remove('sidebar-minimized')
      // Sem isto a sidebar-peek fica orfa: como os gatilhos daqui sao cliques DENTRO da
      // barra (ex: "Menu padrao" do SettingsSidebar), nao ha mouseleave nem timer
      // pendente pra limpar. Ela so reapareceria junto com a proxima
      // Tools.MinimizedSidebar(), travando a barra em 300px com o .main em 50px.
      this.onSidebarPeekCancel()
      window.scrollTo(0, 0)
    },
    isNotProduction () {
      return process.env.NODE_ENV !== 'production'
    }
  }
}
</script>

<style scoped>
.nav-link {
  cursor: pointer;
}

a:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/Sidebar.vue